<template>
    <div>
		<template v-if="vendor_report === true && vendor_categories != null && cities != null && departments != null">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Vendor Report </h1>
            </div>
            <div class="peopple-managment-main">
                <div class="people-management-inner-content pt-5 pb-0 pl-5 pr-5">
					<div class="row">
						<div class="col-md-3">
                    		<div class="form-group">
                    			<label class="label block-label"> Vendor Name </label>
                    			<input name="vendor_name" class="form-control" v-model="vendor_name" placeholder="Enter vendor name">
                    		</div>
                    	</div>
                    	<div class="col-md-3">
                    		<div class="form-group">
                    			<label class="label block-label"> Vendor Number </label>
                    			<input name="vendor_number" class="form-control" v-model="vendor_number" placeholder="Enter vendor number">
                    		</div>
                    	</div>
                    	  <div class="col-md-6">
							<div class="form-group">
                                <label class="label block-label"> Department </label>
								<select v-model="department_id" name="department_id" class="form-control selectpicker custom-select2" v-if="departments != null">
									<option value="" selected>Select Department</option>
									<option v-for="department in departments" v-bind:value="department.id" v-bind:key="department.id">
										{{ department.name }}
									</option>
								</select>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-3">
							<div class="form-group">
                                <label class="label block-label"> Vendor Category </label>
								<select v-model="vendor_category" name="vendor_category" class="form-control selectpicker custom-select2"  v-if="vendor_categories != null">
									<option value="" selected>Select Vendor Category</option>
									<option v-for="vendor_category in vendor_categories" v-bind:value="vendor_category.id" v-bind:key="vendor_category.id">
										{{ vendor_category.name }}
									</option>
								</select>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
                                <label class="label block-label"> City </label>
								<select v-model="city_id" name="city_id" class="form-control selectpicker custom-select2" v-if="cities != null">
									<option value="" selected>Select City</option>
									<option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id">
										{{ city.name }}
									</option>
								</select>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
                                <label class="label block-label"> Account Type </label>
                                <select v-model="account_type" name="account_type" class="form-control selectpicker custom-select2" >
                                    <option value="" selected>Select Account Type</option>
                                    <option value="SIMSIM" v-if="$global.user_company_payment_engine == 'FINCA'">SIMSIM</option>
                                    <option value="EASY_PAISA_WALLET" v-if="$global.user_company_payment_engine == 'EASY_PAISA'">Easypaisa Wallet</option>
                                    <option value="EASY_PAISA_CNIC" v-if="$global.user_company_payment_engine == 'EASY_PAISA'">Easypaisa CNIC</option>
                                    <option value="IBFT">IBFT</option>
                                </select>
							</div>
						</div>
                      
					</div>
					<div class="row">
						
						<div class="col-md-3">
                            <div class="form-group">
                                <label class="label block-label"> From Date </label>
                                <datepicker name="from_date" v-model="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="label block-label"> To Date </label>
                                <datepicker name="to_date" v-model="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date"></datepicker>
                            </div>
                        </div>
						<div class="col-md-3">
							<div class="form-group align-right">
                                <br>
                                <button @click="getVendorReport" v-if="!showBtn" class="btn btn-primary">Search</button>
								<button @click="filterTable" v-if="showBtn" class="btn btn-primary">Search</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="tab-content" id="myTabContent">
                <div v-show="!hasPer" class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                    <div class="empty-main pt-0" style="height: 100px">
                        <div class="empty-inner">
                            <img src="/images/new_empty_payments.png" alt="" />
                            <h2> Hi, {{user}}! </h2>
                            <p> Select your requirements and export your desired report </p>
                        </div>
                    </div>
                </div>
                <div v-show="hasPer">
                    <div class="mt-3 mb-3 tbl-fiters-search-area  hidden-xs" v-if="export_vendor_report === true">
                        <div class="field-box export-attendance">
                            <button class="btn btn-primary export" @click="exportReport">Export Report</button>
                        </div>
                    </div>


                    <div class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                        <table id="vendorReportTable" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th style="display: none">ID</th>
                                    <th>Name</th>
                                    <th>Mobile Number</th>
                                    <th>Email</th>
                                    <th>Account Type</th>
                                    <th>Bank Name</th>
                                    <th>Account Number</th>
                                    <th>Category</th>
                                    <th>City</th>
                                    <th>Department</th>
                                    <th>Added Date</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
			</div>
        </template>
        <template v-else-if="vendor_report === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="vendor_report === false">
            <notAllowed></notAllowed>
        </template>

    </div>
</template>

<script>
	var dtTable = null;
    export default {
        data() {
            return {
				vendor_category : '',
				city_id : '',
				department_id : '',
				vendor_name : '',
				vendor_number : '',
				from_date : '',
				to_date : '',
				// filter data
                vendor_categories : null,
                cities : null,
				departments: null,
				account_type : '',
				hasPer: false,
				user: '',
				vendor_report: null,
				export_vendor_report: null,
				showBtn: false
            };
        },
        mounted() {
			this.can('vendor_report|export_vendor_report').then(result => {
                this.vendor_report = result.vendor_report;
                this.export_vendor_report = result.export_vendor_report;
                this.user = result.user_name;
            }).then(result => {
                if(this.vendor_report == true){
					this.loadFiltersData();
                }
			});
        },
        methods: {
            loadFiltersData: function(){
                this.$Progress.start();
                axios.get('/api/vendor_report_data')
					.then(res => {
						if(res.status == 200){
                            this.vendor_categories = res.data.vendor_categories;
                            this.cities = res.data.cities;
                            this.departments = res.data.departments;
							this.$Progress.finish();
						}else{
							this.$Progress.fail();
                            this.showAlertBox('error','Error to load data');
						}
                    })
                    .then(res=>{
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
					.catch(err => {
						this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
					});
			},
			filterTable(){
	            this.$Progress.start();
				dtTable.draw();
				this.$Progress.finish();
			},
			exportReport: function(){
				this.$Progress.start();
				var formData = {
					'to_date': moment(this.to_date).format('YYYY-MM-DD'),
					'from_date': moment(this.from_date).format('YYYY-MM-DD'),
					'vendor_category': this.vendor_category,
					'city': this.city_id,
					'account_type': this.account_type,
					'department': this.department_id,
					'vendor_name': this.vendor_name,
					'vendor_number': this.vendor_number,
                }
                axios.post('/api/vendor_export', formData,{
					responseType: 'blob'
				})
				.then(res => {
					if(res.status == 200){
						const url = URL.createObjectURL(new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					}))

					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', 'vendorReport.xlsx')
					document.body.appendChild(link)
					link.click()
					this.$Progress.finish();
					}else{
						this.$Progress.fail();
						this.showAlertBox('error','Error to load data');
					}
				})
				.catch(err => {
					this.$Progress.fail();
					this.showAlertBox('error','Error to load data');
				});
			},
            getVendorReport: function(){
	            this.$Progress.start();
				var that = this;
				dtTable = $('#vendorReportTable').DataTable({
					sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
					processing: true,
					serverSide: true,
					ajax: {
						"url": "api/vendor_report",
						"data": function (d) {
							d.vendor_category = that.vendor_category;
							d.department = that.department_id;
							d.city = that.city_id;
							d.account_type = that.account_type;
							d.vendor_name = that.vendor_name;
							d.vendor_number = that.vendor_number;
							d.from_date = moment(that.from_date).format('YYYY-MM-DD');
							d.to_date = moment(that.to_date).format('YYYY-MM-DD');
						},
						"headers": window.axios.defaults.headers.common,
						"dataSrc": "records",
					},
					deferRender: true,
					columns: [
						{data: 'id', visible: false},
						{render: function(data,type,full){
							if(full.name != null){
								return full.name;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							if(full.mobile_no != null){
								return full.mobile_no;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							if(full.email != null){
								return full.email;
							}else{
								return "---";
							}
						}},
                        {render: function(data,type,full){
							if(full.default_beneficiary != null){
								return full.default_beneficiary.account_type;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
                            if(full.default_beneficiary != null){
                                return full.default_beneficiary.bank_name;
                            }else{
                                return "---";
                            }
						}},
						{render: function(data,type,full){
							if(full.default_beneficiary != null){
								return full.default_beneficiary.account_number;
							}else{
                                return "---";
                            }
						}},
						{render: function(data,type,full){
							if(full.category != null){
								return full.category.name;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							if(full.city != null){
								return full.city.name;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							if(full.department != null){
								return full.department.name;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							var date = full['created_at'];
							return ''+moment(date).format('MMM D, Y')+'';
						}},
					],
					"order": [[ 0, "desc" ]],
					"initComplete": (res) => {
						that.hasPer = true;
						that.showBtn = true;
						setTimeout(function(){
							$('select.selectpicker').selectpicker();
						},300);
						that.$Progress.finish();
					}
				});
            }
        },
        created() {
			//
        }
    }
</script>
